
const DsfTemplate1HomeHeader = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_home_template1" */ "./homeHeader"));
const DsfTemplate1HomeMenu = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_home_template1" */ "./homeMenu"));
export default {
  install(Vue) {
    Vue.component("DsfTemplate1HomeHeader", DsfTemplate1HomeHeader);
    Vue.component("DsfTemplate1HomeMenu", DsfTemplate1HomeMenu);
  }
};
